// สรุปถาดขึ้น–ถาดกลับ — kept free of imports so the sidebar and the router can read the path
// without pulling the page's helpers in.

export const PALLET_SUMMARY_PATH = "/report/pallet-summary";

export const PALLET_SUMMARY_TITLE = "สรุปถาดขึ้น–ถาดกลับ";

/**
 * The page's query string. The level is read off which of the scope keys are present, and the
 * names match the API's own parameters.
 */
export const PALLET_SUMMARY_PARAM = {
  startDate: "start_date",
  endDate: "end_date",
  branchCode: "branch_code",
  routeUuid: "route_uuid",
} as const;

/** ภาพรวมทุกสาขา (one row per branch) → สาขา (per route) → สายส่ง (per trip). */
export const PALLET_SUMMARY_LEVEL = {
  overview: "overview",
  branch: "branch",
  route: "route",
} as const;

export type PalletSummaryLevel =
  (typeof PALLET_SUMMARY_LEVEL)[keyof typeof PALLET_SUMMARY_LEVEL];

/** The API refuses a wider range, so the page says so instead of asking. */
export const MAX_RANGE_DAYS = 366;

export const API_DATE_FORMAT = "YYYY-MM-DD";

/** Shown wherever a trip never recorded the value. */
export const EMPTY_VALUE = "—";

/** The หมายเหตุ column: a trip's note, and on a route the notes of its trips. */
export const NOTE_LABEL = "หมายเหตุ";

/** In orange where a มีส่วนต่าง trip has no หมายเหตุ yet. */
export const UNEXPLAINED_TEXT = "ยังไม่ระบุเหตุผล";

/**
 * Narrower than รายงานการโอน's หมายเหตุ (280 px): at that width the สายส่ง, พนักงานขาย and รถ
 * columns beside it wrap at 1440 px with the sidebar collapsed.
 */
export const NOTE_MAX_WIDTH = 210;
